import React from 'react';

import useWindowSize from '@hooks/useWindowSize';
import { OfferOption, SelectedExtendedOffer } from '@utils/backend-api/subscribe';
import { WIDTH_MD } from '@utils/constants';

import ChoosePlanHeader from './ChoosePlanHeader';
import CorporateInquiry from './CorporateInquiry';
import MultipleOffers from './MultipleOffers';
import SignupForm from './SignupForm';

interface OfferSelectionProps {
  description?: string;
  offers: OfferOption[];
  onFormSubmit: () => void;
  selectedOffer?: SelectedExtendedOffer;
  setSelectedOffer: (offer: SelectedExtendedOffer) => void;
}

const OfferSelection = ({
  description,
  offers,
  onFormSubmit,
  selectedOffer,
  setSelectedOffer,
}: OfferSelectionProps) => {
  const { width: windowWidth } = useWindowSize();

  return (
    <div className="pb-80 pt-32 sm:px-28 sm:pb-96 sm:pt-48 lg:pb-112 lg:pt-64">
      <div className="mx-auto max-w-full sm:max-w-[712px] md:max-w-[1040px]">
        <ChoosePlanHeader description={description} />
        <MultipleOffers
          offers={offers}
          onFormSubmit={onFormSubmit}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
        />
        {selectedOffer && windowWidth >= WIDTH_MD && (
          <SignupForm
            formLocation={'subscribe_h'}
            presentedOfferCodes={offers.map((offer) => offer.code)}
            onFormSubmit={onFormSubmit}
            selectedOffer={selectedOffer}
          />
        )}
      </div>
      <CorporateInquiry />
    </div>
  );
};

export default OfferSelection;
